import { render, staticRenderFns } from "./OnlineStoreGroups.vue?vue&type=template&id=6d05bc7b&"
import script from "./OnlineStoreGroups.vue?vue&type=script&lang=js&"
export * from "./OnlineStoreGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports